import React from "react";
import { LaunchableFromList } from "server";

import { DeleteConfirmModal } from "./index";

interface DeleteLaunchableConfirmModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  onDelete: () => void;
  launchable: LaunchableFromList;
  orgName?: string;
}

export const DeleteLaunchableConfirmModal: React.FC<
  DeleteLaunchableConfirmModalProps
> = ({ show, setShow, onDelete, launchable, orgName }) => (
  <DeleteConfirmModal
    show={show}
    setShow={setShow}
    onDelete={onDelete}
    resourceName={launchable.name}
    resourceLabel="Launchable"
    title="Permanently Delete Launchable"
    bullets={
      <>
        <li>
          This launchable will be{" "}
          <strong>permanently removed from your organization</strong>
        </li>
        <li>
          Existing environments deployed from this launchable will not be
          affected
        </li>
        <li>This action cannot be undone</li>
      </>
    }
    orgName={orgName}
  />
);
